export const CONTACT_EMAIL = "contact@thecodingyogi.me";
export const LINKEDIN_URL = "https://www.linkedin.com/in/nicholeuf";
export const GITHUB_URL = "https://github.com/nicholeuf";

export const getEmailHref = () => `mailto:${CONTACT_EMAIL}`;
